"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TupleArbitrary = void 0;

var Stream_1 = require("../../stream/Stream");

var symbols_1 = require("../../check/symbols");

var NextArbitrary_1 = require("../../check/arbitrary/definition/NextArbitrary");

var NextValue_1 = require("../../check/arbitrary/definition/NextValue");

var TupleArbitrary = /*#__PURE__*/function (_NextArbitrary_1$Next) {
  _inherits(TupleArbitrary, _NextArbitrary_1$Next);

  var _super = _createSuper(TupleArbitrary);

  function TupleArbitrary(arbs) {
    var _this;

    _classCallCheck(this, TupleArbitrary);

    _this = _super.call(this);
    _this.arbs = arbs;

    for (var idx = 0; idx !== arbs.length; ++idx) {
      var arb = arbs[idx];
      if (arb == null || arb.generate == null) throw new Error("Invalid parameter encountered at index ".concat(idx, ": expecting an Arbitrary"));
    }

    return _this;
  }

  _createClass(TupleArbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      return TupleArbitrary.wrapper(this.arbs.map(function (a) {
        return a.generate(mrng, biasFactor);
      }));
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      if (!Array.isArray(value) || value.length !== this.arbs.length) {
        return false;
      }

      for (var index = 0; index !== this.arbs.length; ++index) {
        if (!this.arbs[index].canShrinkWithoutContext(value[index])) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "shrink",
    value: function shrink(value, context) {
      var _this2 = this;

      var s = Stream_1.Stream.nil();
      var safeContext = Array.isArray(context) ? context : [];

      var _loop = function _loop(idx) {
        var shrinksForIndex = _this2.arbs[idx].shrink(value[idx], safeContext[idx]).map(function (v) {
          var nextValues = value.map(function (v, idx) {
            return new NextValue_1.NextValue((0, symbols_1.cloneIfNeeded)(v), safeContext[idx]);
          });
          return nextValues.slice(0, idx).concat([v]).concat(nextValues.slice(idx + 1));
        }).map(function (values) {
          return TupleArbitrary.wrapper(values);
        });

        s = s.join(shrinksForIndex);
      };

      for (var idx = 0; idx !== this.arbs.length; ++idx) {
        _loop(idx);
      }

      return s;
    }
  }], [{
    key: "makeItCloneable",
    value: function makeItCloneable(vs, values) {
      return Object.defineProperty(vs, symbols_1.cloneMethod, {
        value: function value() {
          var cloned = [];

          for (var idx = 0; idx !== values.length; ++idx) {
            cloned.push(values[idx].value);
          }

          TupleArbitrary.makeItCloneable(cloned, values);
          return cloned;
        }
      });
    }
  }, {
    key: "wrapper",
    value: function wrapper(values) {
      var cloneable = false;
      var vs = [];
      var ctxs = [];

      for (var idx = 0; idx !== values.length; ++idx) {
        var v = values[idx];
        cloneable = cloneable || v.hasToBeCloned;
        vs.push(v.value);
        ctxs.push(v.context);
      }

      if (cloneable) {
        TupleArbitrary.makeItCloneable(vs, values);
      }

      return new NextValue_1.NextValue(vs, ctxs);
    }
  }]);

  return TupleArbitrary;
}(NextArbitrary_1.NextArbitrary);

exports.TupleArbitrary = TupleArbitrary;